module.exports = __webpack_public_path__ + "static/img/MockGalleryFeatures.70ccc14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MockGalleryFeatures.png
// module id = 5AUI
// module chunks = 1